import { render, staticRenderFns } from "./VerifyEmailContent.vue?vue&type=template&id=ed555f5e&scoped=true"
import script from "./VerifyEmailContent.vue?vue&type=script&lang=js"
export * from "./VerifyEmailContent.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmailContent.vue?vue&type=style&index=0&id=ed555f5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed555f5e",
  null
  
)

export default component.exports